import {Component, computed, input} from "@angular/core";
import {environment} from "src/environments/environment";

export enum AppStoreButtonType {
    GOOGLE_PLAY,
    APP_STORE,
}

/**
 * Button component that links to the corresponding app store for the platform passed (Google Play or App Store).
 */
@Component({
    standalone: true,
    selector: 'app-app-store-button',
    templateUrl: './app-store-button.component.html',
    styleUrl: './app-store-button.component.scss',
})
export class AppStoreButtonComponent {
    protected readonly GOOGLE_PLAY_LINK = environment.GOOGLE_PLAY_LINK;
    protected readonly APP_STORE_LINK = environment.APP_STORE_LINK;

    type = input.required<AppStoreButtonType>();

    protected readonly imageUrl = computed(() => {
        return this.type() === AppStoreButtonType.GOOGLE_PLAY ? 'assets/img/button-google-play.svg' : 'assets/img/button-app-store.svg';
    });
    protected readonly link = computed(() => {
        return this.type() === AppStoreButtonType.GOOGLE_PLAY ? this.GOOGLE_PLAY_LINK : this.APP_STORE_LINK;
    });
}